import cssVars from "css-vars-ponyfill";
import "intersection-observer";

cssVars();
